module.exports = __webpack_public_path__ + "img/c03_unitcargoexpansion_Normal_ua.2edc0f79.webp";